<template>
  <v-container fluid fill-height class="d-flex">
    <v-layout justify-center align-start>
      <v-flex lg8 md10 sm11 xs12>
        <v-card class="br-10 pa-4 text-center">
          <span class="title pb-3"><strong>{{ $t('feedback_history') }}</strong></span>
          <v-data-iterator content-tag="v-layout" row wrap :items="list" :items-per-page="10">
            <v-layout slot="item" slot-scope="props" xs12 sm6 md4 lg4 class="d-flex">
              <v-card class="elevation-0">
                <v-card-title @click="$router.push('/feedback/detail/' + props.item._id)">
                  <span class="body-2 font-weight-bold">{{ props.item.date | dateTime }}</span>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-item @click="$router.push('/feedback/detail/' + props.item._id)">
                    <v-list-item-content style="width: 50%">{{ $t('reference_no') }}:</v-list-item-content>
                    <v-list-item-content style="width: 50%" class="font-weight-bold primary--text">{{ props.item._id }}</v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content style="width: 50%">{{ $t('status') }}:</v-list-item-content>
                    <v-list-item-content style="width: 50%" class="font-weight-bold">{{ $t(props.item.status) }}</v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content style="width: 50%">{{ $t('subject') }}:</v-list-item-content>
                    <v-list-item-content style="width: 50%" class="font-weight-bold">{{ props.item.subject }}</v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content style="width: 50%">{{ $t('description') }}:</v-list-item-content>
                    <v-list-item-content style="width: 50%" class="font-weight-bold">{{ props.item.description }}</v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-layout>
          </v-data-iterator>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import vuex from 'vuex'
export default {
  computed: {
    ...vuex.mapState({
      list: state => state.feedback.list,
      iterator: state => state.feedback.iterator
    })
  },
  created: function () {
    const fetchSession = this.$store.dispatch('auth/session')
    fetchSession.then(function (response) {
      if (response.userCtx.name === '' || response.userCtx.name === 'couchdb') {
        this.$router.push('/')
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: 'Pengguna tidak dijumpai. Sila log masuk semula.',
          visible: true
        })
        return
      }
      this.$store.dispatch('feedback/fetchList')
    }.bind(this))
  },
  methods: {
    ...vuex.mapActions({
      fetchList: 'feedback/fetchList'
    })
  }
}
</script>
